import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

import { Avatar, Box, Container, Tab, Tabs, Typography } from '@mui/material'
import React, { ReactElement, useState } from 'react'
import { useAppSelector } from 'src/store/hooks'
import { selectUseEvents } from 'src/v3/settings/settings.slice'
import Sessions from 'src/v3/events/sessions'
import Quiz from 'src/v3/events/quiz'
import { EventForm } from './event-form'

dayjs.extend(utc)

export default (): ReactElement => {
  let useEvents = useAppSelector(selectUseEvents)
  let [step, setStep] = useState<'details' | 'sessions' | 'quiz'>('details')

  return useEvents ? (
    <Container maxWidth="xl">
      <Box sx={{ mt: -18 }}></Box>
      <Tabs variant="fullWidth" value={step}>
        {[
          { step: 'details', label: 'Event Details' },
          { step: 'sessions', label: 'Sessions' },
          { step: 'quiz', label: 'Quiz' },
        ].map((tab, i) => (
          <Tab
            key={tab.step}
            value={tab.step}
            label={tab.label}
            icon={
              <Avatar
                sx={{
                  width: 24,
                  height: 24,
                  fontSize: 16,
                  color: step === tab.step ? undefined : 'text.secondary',
                  bgcolor:
                    step === tab.step ? 'primary.main' : 'background.paper',
                }}
              >
                {i + 1}
              </Avatar>
            }
            iconPosition="start"
            sx={{ my: -1, cursor: 'auto', textTransform: 'none' }}
          />
        ))}
      </Tabs>
      <Box sx={{ my: 5, display: 'flex', justifyContent: 'space-between' }}>
        <Box>
          <Typography variant="h5" sx={{ fontWeight: 700, mb: 0.5 }}>
            Create New Event
          </Typography>
          <Typography variant="subtitle1" color="textSecondary">
            Set up your event details, sessions, and quiz
          </Typography>
        </Box>
      </Box>
      {step === 'details' && <EventForm setStep={setStep} />}
      {step === 'sessions' && <Sessions setStep={setStep} eventView="edit" />}
      {step === 'quiz' && <Quiz setStep={setStep} />}
    </Container>
  ) : (
    <></>
  )
}
